import { Controller } from "@hotwired/stimulus"

const RE = /\b(T\d{4}(?:\.\d{3})?)\b/g

// Scans table cells for MITRE ATT&CK technique IDs (T1059, T1059.003, etc.)
// and replaces them with links to attack.mitre.org. Works on dynamically
// streamed rows via MutationObserver.
export default class extends Controller {
  #observer = null

  connect() {
    this.#scan(this.element)
    this.#observer = new MutationObserver(mutations => {
      mutations.forEach(m => {
        m.addedNodes.forEach(n => {
          if (n.nodeType === Node.ELEMENT_NODE) this.#scan(n)
        })
      })
    })
    this.#observer.observe(this.element, { childList: true, subtree: true })
  }

  disconnect() { this.#observer?.disconnect() }

  #scan(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null)
    const nodes = []
    let node
    while ((node = walker.nextNode())) {
      if (node.parentElement?.closest(".siem-mitre-tag, a")) continue
      RE.lastIndex = 0
      if (RE.test(node.textContent)) nodes.push(node)
    }
    nodes.forEach(n => this.#replace(n))
  }

  #replace(textNode) {
    const frag = document.createDocumentFragment()
    let last = 0
    let match
    RE.lastIndex = 0

    while ((match = RE.exec(textNode.textContent)) !== null) {
      if (match.index > last) {
        frag.appendChild(document.createTextNode(textNode.textContent.slice(last, match.index)))
      }
      const id = match[1]
      const a = document.createElement("a")
      a.href = `https://attack.mitre.org/techniques/${id.replace(".", "/")}/`
      a.target = "_blank"
      a.rel = "noopener noreferrer"
      a.className = "siem-mitre-tag"
      a.title = `MITRE ATT&CK: ${id}`
      a.textContent = id
      frag.appendChild(a)
      last = match.index + id.length
    }

    if (last < textNode.textContent.length) {
      frag.appendChild(document.createTextNode(textNode.textContent.slice(last)))
    }
    textNode.parentNode.replaceChild(frag, textNode)
  }
}
